<template functional>
  <el-dropdown-item
    class="zk-dropdown-item"
    :class="[data.class, { 'is-active': props.active }]"
    :icon="props.icon"
    @click.native="listeners.click"
  >
    <span
      v-overflow-tooltip="props.title"
      :class="['zk-dropdown-item__title', 'text-ellipsis']"
    >
      {{ props.title }}
    </span>
    <slot name="suffix">
      <template v-for="(key, index) in props.hotKey">
        <em
          v-if="props.hotKey.length > 1 && index !== 0"
          :key="index"
          :class="['zkicon icontianjia_xiao']"
          class="emi"
        />
        <el-tag
          :key="key + index"
          :class="['zk-dropdown-item__tag']"
        >
          <span>
            {{ key }}
          </span>
        </el-tag>
      </template>
      <el-new-badge
        v-if="props.newSegments"
        :icon-size="26"
        class="zk-dropdown-item__new-badge"
        :segments="props.newSegments"
        placement="right"
      />
      <em
        v-if="props.blank"
        class="zkicon iconxinbiaoqiandakai1"
      />
    </slot>
  </el-dropdown-item>
</template>

<script>
export default {
  name: 'DropdownItem'
};
</script>

<style lang="scss">
@include b(dropdown-item) {
  display: flex;
  align-items: center;
  @include e(title) {
    flex: 1;
    padding-right: 8px;
  }
  @include e(tag) {
    min-width: 32px;
    height: 20px!important;
    line-height: 20px!important;
    border: 0!important;
    color: #000000!important;
    background: rgba($color: #000000, $alpha: 0.04)!important;
    border-radius: 2px;
    padding: 0 8px !important;
    text-align: center;
    font-size: var(--size-font-7);
  }
  .emi{
    padding: 0 4px !important;
    color: var(--font-color-1);
  }
  .iconxinbiaoqiandakai1 {
    color: var(--purpleGray-6);
  }
  @include when(active) {
    background: rgba(60, 62, 192, 0.06);
  }
}
.zk-dropdown-item__new-badge {
  margin-left: var(--m-small);
  svg {
    width: 26px !important;
  }
}
</style>
